export default "__VITE_ASSET__BswiuyCj__"